/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum UserSearchesType {
  candidate = "candidate",
  opportunity = "opportunity",
}

export const UserSearchesTypeDisplay: Record<UserSearchesType, string> = {
  [UserSearchesType.candidate]: "Candidate",
  [UserSearchesType.opportunity]: "Opportunity",
};
